module.exports = __webpack_public_path__ + "media/images/scorecards-empty-b5d2b09e223571551b1479d3de433fc5.svg";